/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PhoneHangUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABPUlEQVR4nO1TO0oEQRBdFDTyBuZ+MsVDDLj9qlroqRo2E8RDKEwiBmLiIfxkYiirIAbeQPECmhgpgga6K63CrLNbM24muA8eNEX1e1XVXY3GCP8bzDIH1k3H2nYsd2B9jYznGAPLRnMlmx1aGNAlkJ6CtQPWbg07Mbfp08Va4RDCOEi2HenbL4S7vYx3HOlW1BgoniTJpGM5GVYYfZTjEMJEn4EjPTSrY23DpwqE+UjHmoHk3DQhOfg5c5+2Brct72Bds0ZKlK1/5/Sb+FQLA5Iro/KjundzrPvG3ctegxejg/s8z8cqDUhvDIOnwoDl2ZwndMES9741XfHYj70dXFhtApiyDOLfr/hRZ0UiZVwSvo6xuvl/Fud1+WurS0sJRXmWO471Fqyr5rJUAAgzjmQPLA9g2a3KHWGEP4YP6mBAtTGCzuIAAAAASUVORK5CYII=)
 */
export const PhoneHangUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m21.5 16.6-.13.14a.88.88 0 0 1-.97.2l-4.09-1.7a.99.99 0 0 1-.57-1.18l.73-2.7c-2.24-3-6.7-3-8.94 0l.7 2.1a.99.99 0 0 1-.48 1.19l-4.13 2.2a.87.87 0 0 1-1.03-.15l-.1-.1a5.18 5.18 0 0 1-.32-6.92 12.67 12.67 0 0 1 19.66 0 5.18 5.18 0 0 1-.32 6.92Z"
        className={colorClass}
      />
    </svg>
  );
};
